import { Row } from "antd";

type DataRowProps = {
  label: string;
  value: string;
  bold?: boolean;
};

export const DataRow = ({ value, label, bold = false }: DataRowProps) => {
  return (
    <Row className="justify-space-between  align-start summaty-row py-4">
      <p className="my-0 text title summary-label">{label}</p>
      <p className={`my-0 summary-value ${bold ? "h h4 w-500" : "text"}`}>
        {value}
      </p>
    </Row>
  );
};
